














































import Vue from 'vue';
import { BounceRecipient } from '@/types';
import InputResultFilter from '@/components/pagination/InputResultFilter.vue';
import BouncesTable from './BouncesTable.vue';

export default Vue.extend({
  props: {
    bounces: {
      type: Array as () => BounceRecipient[],
      default() {
        return [];
      },
    },
  },
  data() {
    return {
      headings: [
        'Email',
        'Name',
        'Reason',
      ],
      softBouncesMaxResults: 10,
      hardBouncesMaxResults: 10,
    };
  },
  computed: {
    filteredSoftBounces(): BounceRecipient[] {
      return this.softBounces.slice(0, this.softBouncesMaxResults);
    },
    filteredHardBounces(): BounceRecipient[] {
      return this.hardBounces.slice(0, this.hardBouncesMaxResults);
    },
    softBounces(): BounceRecipient[] {
      return this.bounces.filter(bounce => bounce.type === 'Soft');
    },
    hardBounces(): BounceRecipient[] {
      return this.bounces.filter(bounce => bounce.type === 'Hard');
    },
  },
  components: {
    'input-result-filter': InputResultFilter,
    'soft-bounces-table': BouncesTable,
    'hard-bounces-table': BouncesTable,
  },
});
